import { Settings } from 'approot/shared/richtext/richtext.constants';

export const TITLE_RICHTEXT_SETTINGS: Settings = {
  placeholder: 'Focus Question',
  canChangeBlockType: false,
  canBold: true,
  canItalic: true,
  canUnderline: false,
  canAddLists: false,
  canChangeHistory: false,
  canChangeFonts: false,
  canAddLinks: false,
  canAlignText: false,
  canHighlight: false,
};
